import api from "../axios.js";

const state = () => ({
  companies: [],
});

const getters = {
  getCompanies: (state) => state.companies,
};

const mutations = {
  setCompanies(state, companies) {
    state.companies = companies;
  },
};

const actions = {
  async fetchCompanies({ commit, rootGetters, dispatch }) {
    const resource = "companies";
    const headers = {};

    // Hämta ETag från global etagStore
    const etag = rootGetters["etag/getETag"](resource);
    if (etag) headers["If-None-Match"] = etag;

    try {
      const res = await api.get(
        `${process.env.VUE_APP_API_BASE_URL}/companies`,
        {
          headers,
          validateStatus: (status) => status === 200 || status === 304,
        }
      );

      if (res.status === 200) {
        commit("setCompanies", res.data);

        const newETag = res.headers.etag;
        if (newETag) {
          dispatch(
            "etag/setETag",
            { resource, value: newETag },
            { root: true }
          );
        }
      } else if (res.status === 304) {
        // Data oförändrad – inget att göra
      }
    } catch (err) {
      console.error("Misslyckades att hämta companies:", err);
      throw err;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
